export class GraphNode {
  name: string;
  group: string | undefined;

  constructor(name: string, group: string) {
    this.name = name;
    this.group = group;
  }
}
